export const FacilityTypes = {
    f1: 'Driving Range',
    f2: 'Putting Green',
    f3 : 'Chipping Green',
    f4: 'Practice Bunker',
    f5: 'Motor Cart',
    f6: 'Pull Cart',
    f7: 'Golf Clubs Rental',
    f8: 'Club Fitting',
    f9: 'Pro Shop',
    f10: 'Golf Lessons',
    f11: 'Caddie Hire',
    f12: 'Restaurant',
    f13: 'Reception Hall',
    f14: 'Changing Room',
    f15: 'Lockers',
    f16: 'Lodging On Site'
    
    };
    export const userTypes = [
        {
            name:"Admin",
            type:3
        },
        {
            name:"Club",
            type:1
        },
        
    ]
    export const masterPermissions = [
        {
            id:"dashboard",
            name:"Dashboard"
        },
        {
            id:"sales_pipeline",
            name:"Sales Pipleline"
        }
    ]

    